import * as React from 'react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import TrashBinDataTable from 'modules/documents/components/TrashBin/TrashBinDataTable'
import { SPACES } from 'modules/documents/lib/constants'

const CompanyPublicTrashPage = () => {
  const { navigation } = useNavigation()

  return (
    <TrashBinDataTable
      space={SPACES.COMPANY_PUBLIC}
      getItemRoute={(documentId) =>
        navigation.files.trash.company_public.documentId.fullPath({ document_id: documentId })
      }
      parentRoute={navigation.files.trash.company_public.fullPath()}
    />
  )
}

export default CompanyPublicTrashPage
